<template>
  <q-layout>
    <q-page-container class="backgroundColor" style="max-height: 100vh; overflow: auto;">
      <q-page class="row">
        <div class="col-12 col-lg-5 q-pa-lg">
          <div class="row justify-center q-pt-lg">
            <img src="hidoe-logo.jpg" class="logo-size" />
          </div>
          <div class="q-pt-lg text-center">
            <p class="text-h3 text-weight-bold" style="margin-bottom: 0px">Welcome to</p>
            <p class="text-h3 text-weight-bold">FacDocs System</p>
          </div>
          <div class="q-pt-xl" style="width: 50%; margin: auto;">
            <div v-if="formDisplay === 'Login'">
              <p class="text-h5 text-weight-bold q-pb-md">Login</p>
              <q-form
                @submit="onSubmitSignIn"
                class="q-gutter-md"
              >
                <q-input
                  filled
                  v-model="emailAddress"
                  label="Email Address"
                  lazy-rules
                  style="width: 100%;"
                  :rules="[
                    (val) => isValidEmail(val) || 'Invalid email address format',
                  ]"
                  :disable="disabledFields"
                />

                <q-input
                  filled
                  v-model="password"
                  label="Password"
                  lazy-rules
                  style="width: 100%;"
                  maxlength="256"
                  :type="passwordVisibility ? 'password' : 'text'"
                  :rules="[ val => val && val.length > 5 || 'Invalid minimum password length']"
                  :disable="disabledFields"
                >
                  <template v-slot:append>
                    <q-icon
                      :name="passwordVisibility ? 'visibility_off' : 'visibility'"
                      class="cursor-pointer"
                      @click="passwordVisibility = !passwordVisibility"
                    />
                  </template>
                </q-input>

                <div class="row q-gutter-md q-mt-none"> 
                  <q-btn label="Reset Password" v-model="formDisplay" no-caps color="primary" @click="setFormDisplay('Reset Password')" :disable="disabledFields"/>
                  <q-space/>
                  <q-btn label="Sign In" no-caps type="submit" color="primary" :disable="disabledFields"/>
                  <q-btn label="Register" v-model="formDisplay" no-caps color="primary" @click="setFormDisplay('Create Account')" :disable="disabledFields"/>
                </div>
              </q-form>
            </div>

            <div v-else-if="formDisplay === 'Reset Password'">
              <p class="text-h5 text-weight-bold q-pb-md">Reset Password</p>
              <q-form
                @submit="onSubmitResetPassword"
                class="q-gutter-md"
              >
                <p style="font-size: 1vw">Get instructions sent to this email that explain how to reset your password.</p>
                <q-input
                  filled
                  v-model="emailAddressResetPassword"
                  label="Email Address"
                  lazy-rules
                  style="width: 100%;"
                  :rules="[
                    (val) => isValidEmail(val) || 'Invalid email address format',
                  ]"
                  :disable="disabledFields"
                />

                <div>
                  <q-btn label="Cancel" no-caps color="cancelButton" @click="setFormDisplay('Login')" style="float: left" :disable="disabledFields"/>
                  <q-btn label="Submit" no-caps type="submit" color="primary" style="float: right" :disable="disabledFields"/>
                </div>
              </q-form>
            </div>

            <div v-else-if="formDisplay === 'Create Account'">
              <p class="text-h5 text-weight-bold q-pb-md">Create Account</p>
              <q-form
                @submit="onSubmitCreateAccount"
                class="q-gutter-md"
              >
                <q-input
                  filled
                  v-model="emailAddressCreateAccount"
                  label="Email Address"
                  lazy-rules
                  style="width: 100%;"
                  :rules="[
                    (val) => isValidEmail(val) || 'Invalid email address format',
                  ]"
                  :disable="disabledFields"
                />

                <q-input
                  filled
                  label="Name"
                  v-model="name"
                  style="width: 100%;"
                  lazy-rules
                  maxlength="256"
                  :rules="[
                    (val) => (val && val.length > 0) || 'Required name',
                  ]"
                  :disable="disabledFields"
                />

                <q-input
                  filled
                  v-model="password"
                  label="Password"
                  lazy-rules
                  style="width: 100%;"
                  maxlength="256"
                  :type="passwordVisibility ? 'password' : 'text'"
                  :rules="[
                    (val) =>
                      validatePassword(val) || createPasswordErrorMessage()
                  ]"
                  :disable="disabledFields"
                >
                  <template v-slot:append>
                    <q-icon
                      :name="passwordVisibility ? 'visibility_off' : 'visibility'"
                      class="cursor-pointer"
                      @click="passwordVisibility = !passwordVisibility"
                    />
                  </template>
                </q-input>

                <div class="q-pt-md">
                  <q-btn label="Cancel" no-caps color="cancelButton" @click="setFormDisplay('Login')" style="float: left" :disable="disabledFields"/>
                  <q-btn label="Submit" no-caps type="submit" color="primary" style="float: right" :disable="disabledFields"/>
                </div>
              </q-form>
            </div>
          </div>
        </div>

        <div class="col-12 col-lg">
          <q-carousel
            arrows
            navigation
            infinite
            autoplay
            animated
            transition-prev="slide-right"
            transition-next="slide-left"
            v-model="carouselSlide"
            height="100vh"
          >
            <q-carousel-slide name="first" img-src="facdoc-login-photo-01.jpg">
              <div class="absolute-bottom custom-caption">
                <div class="carousel-caption">Discover and Retrieve<br />Archived Documents</div>
              </div>
            </q-carousel-slide>
            <q-carousel-slide name="second" img-src="facdoc-login-photo-02.jpg">
              <div class="absolute-bottom custom-caption">
                <div class="carousel-caption">Search for Documents<br />by School</div>
              </div>
            </q-carousel-slide>
            <q-carousel-slide name="third" img-src="facdoc-login-photo-03.jpg">
              <div class="absolute-bottom custom-caption">
                <div class="carousel-caption">Customize Search</div>
              </div>
            </q-carousel-slide>
          </q-carousel>
        </div>
      </q-page>
    </q-page-container>
  </q-layout>
</template>

<script>
import { ref, watchEffect } from 'vue';
import router from "../../router/index.js";
import NotificationHelper from "../helper/NotificationHelper.js";
import EmailService from "../service/EmailService.js";
import FirebaseService from "../service/FirebaseService.js";
import { auth } from '../firebase/config.js';
import { createUserWithEmailAndPassword, sendPasswordResetEmail, signInWithEmailAndPassword, updateProfile } from 'firebase/auth';
import axios from "axios";

export default {
  name: "LoginPage",
  setup() {
    const carouselSlide = ref("first");
    const emailAddress = ref("");
    const password = ref("");
    const passwordVisibility = ref(true);
    const disabledFields = ref(false);

    const { user } = FirebaseService.getUser();

    watchEffect(() => {
      if (user.value && !disabledFields.value) {
        router.replace('/');
      }
    });

    function isValidEmail(email) {
      const emailPattern =
        /^(?=[a-zA-Z0-9@._%+-]{6,254}$)[a-zA-Z0-9._%+-]{1,64}@(?:[a-zA-Z0-9-]{1,63}\.){1,8}[a-zA-Z]{2,63}$/;
      return emailPattern.test(email);
    }

    async function onSubmitSignIn() {
      try {
        disabledFields.value = true;
        await signInWithEmailAndPassword(auth, emailAddress.value, password.value);
        disabledFields.value = false;
      } catch (error) {
        disabledFields.value = false;
        if (error.code === "auth/invalid-credential") {
          NotificationHelper.createErrorNotification("Invalid login credentials.");
        } else if (error.code === "auth/too-many-requests") {
          NotificationHelper.createNotification(
            "Access to this account has been temporarily disabled due to many failed login attempts. You can immediately restore it by resetting your password or you can try again later.",
            {
              timeout: 10000,
              type: "negative"
            }
          );
        } else {
          EmailService.sendErrorEmail("LoginPage.vue - onSubmitSignIn", error);
          NotificationHelper.createErrorNotification("Error encountered. Please try again.");
        }
      }
    }

    const emailAddressResetPassword = ref("");
    const formDisplay = ref("Login");

    function setFormDisplay(mode) {
      formDisplay.value = mode;
      clearFields();
    }

    async function onSubmitResetPassword() {
      disabledFields.value = true;
      try {
        await sendPasswordResetEmail(auth, emailAddressResetPassword.value);
      } catch (error) {
        EmailService.sendErrorEmail("LoginPage.vue - onSubmitResetPassword", error);
        // Catches error but won't do anything
      }

      NotificationHelper.createNotification(
        "If we have an account matching your email address, you will receive an email with a link to reset your password.",
        {
          timeout: 10000,
          type: "positive"
        }
      );
      setFormDisplay("Login");
      disabledFields.value = false;
    }

    const emailAddressCreateAccount = ref("");
    const name = ref("");

    const validPassword = ref({
      length: false,
      lowercase: false,
      uppercase: false,
      number: false,
      symbol: false
    });

    function validatePassword(password) {
      // Test length: At least 12 characters long
      validPassword.value.length = password.length >= 12;

      // Test lowercase: At least one lowercase letter
      validPassword.value.lowercase = /^(?=.*[a-z])/.test(password);

      // Test uppercase: At least one uppercase letter
      validPassword.value.uppercase = /^(?=.*[A-Z])/.test(password);

      // Test number: At least one number
      validPassword.value.number = /^(?=.*[0-9])/.test(password);

      // Test symbol: At least one special character
      validPassword.value.symbol = /^(?=.*[\^\$*\.\[\]\{\}\(\)\?\"!@#%&\/\\,><':;|_~`])/.test(password);

      return (
        validPassword.value.length &&
        validPassword.value.lowercase &&
        validPassword.value.uppercase &&
        validPassword.value.number &&
        validPassword.value.symbol
      );
    }

    function createPasswordErrorMessage() {
      let description = [];

      Object.keys(validPassword.value).forEach((key) => {
        if (!validPassword.value[key]) {
          switch (key) {
            case "length":
              description.push("12 characters");
              break;
            case "lowercase":
              description.push("one lowercase character");
              break;
            case "uppercase":
              description.push("one uppercase character");
              break;
            case "number":
              description.push("one numeric character");
              break;
            case "symbol":
              description.push("one non-alphanumeric character");
              break;
          }
        }
      });

      return `Password must contain at least: ${description.join(", ")}`;
    }

    async function onSubmitCreateAccount() {
      try {
        disabledFields.value = true;
        await createUserWithEmailAndPassword(auth, emailAddressCreateAccount.value, password.value);
        await updateProfile(auth.currentUser, { displayName: name.value });
        axios.get(`${process.env.VUE_APP_API_GATEWAY}sendAccountCreatedEmailNotification?name=${name.value}&emailAddress=${emailAddressCreateAccount.value}&key=${process.env.VUE_APP_API_KEY}`);
        disabledFields.value = false;
        NotificationHelper.createSuccessNotification("Account Created");
      } catch (error) {
        disabledFields.value = false;
        if (error.code === "auth/email-already-in-use") {
          NotificationHelper.createNotification(
            "The email address already exists. Please reset your password if necessary.",
            {
              timeout: 10000,
              type: "negative"
            }
          );
        } else if (error.code === "auth/password-does-not-meet-requirements") {
          NotificationHelper.createErrorNotification("Password does not meet requirements.");
        } else {
          EmailService.sendErrorEmail("LoginPage.vue - onSubmitCreateAccount", error);
          NotificationHelper.createErrorNotification("Error encountered. Please try again.");
        }
      }
    }

    function clearFields() {
      emailAddressResetPassword.value = "";
      emailAddressCreateAccount.value = "";
      name.value = "";
      emailAddress.value = "";
      password.value = "";
      passwordVisibility.value = true;
    }

    return {
      // variable properties
      carouselSlide,
      emailAddress,
      password,
      passwordVisibility,
      disabledFields,
      formDisplay,
      emailAddressResetPassword,
      emailAddressCreateAccount,
      name,

      //functions
      isValidEmail,
      onSubmitSignIn,
      setFormDisplay,
      onSubmitResetPassword,
      validatePassword,
      createPasswordErrorMessage,
      onSubmitCreateAccount
    };
  }
}
</script>

<style scoped>
.backgroundColor {
  background-color: white
}

.logo-size {
  width: 250px;
  height: 250px;
}

.carousel-caption {
  margin-bottom: 14%;
  margin-left: 15%;
  font-weight: bold;
  font-size: 48px;
  color: white;
  text-shadow: #000 0px 2px 8px;
}

</style>
